import axiosInstance from '../utils/AxiosConfig';

export const getSettings = async () => {
  try {
    const response = await axiosInstance.get('/settings');
    return response.data.data;
  } catch (error) {
    console.error('Error getting settings', error);
    throw new Error('Error fetching staff');
  }
};

export const getLocationSalesViewMode = async (locationId) => {
  const response = await axiosInstance.get(`/settings/location-sales-view-mode/${locationId}`);
  return response.data?.data?.mode || 'touch';
};

export const getLocationSalesConfig = async (locationId) => {
  const response = await axiosInstance.get(`/settings/location-sales-config/${locationId}`);
  const data = response.data?.data || {};
  return {
    mode: data.mode || 'touch',
    mercadoPagoActive: data.mercadoPagoActive === true,
    posActive: data.posActive === true,
    electronicBilling: {
      selectedProvider: data.electronicBilling?.selectedProvider || 'FACTURA_LISTA'
    }
  };
};

export const getSitesOrdersConfig = async () => {
  const response = await axiosInstance.get('/settings/sites-orders-config');
  const data = response.data?.data || {};
  return {
    deliveryIntegrationEnabled: data.deliveryIntegrationEnabled !== false
  };
};

export const updateSitesOrdersConfig = async ({ deliveryIntegrationEnabled }) => {
  try {
    await axiosInstance.post('/settings/sites-orders-config', {
      settings: [
        {
          key: 'delivery_integration_enabled',
          value: deliveryIntegrationEnabled ? 'true' : 'false'
        }
      ]
    });
    return true;
  } catch (error) {
    console.error('Error updating sites orders config:', error);
    return false;
  }
};

export const getSitesOrdersPrintConfig = async (locationId) => {
  const response = await axiosInstance.get(`/settings/sites-orders-print-config/${locationId}`);
  const data = response.data?.data || {};
  return {
    viewPrint: data.viewPrint === true,
    autoPrint: data.autoPrint === true,
    comandaPrint: data.comandaPrint === true,
    loyaltyCardPrintAvailable: data.loyaltyCardPrintAvailable === true,
    loyaltyCardPrint: data.loyaltyCardPrint === true
  };
};

export const updateSettings = async (data) => {
  try {
    await axiosInstance.post('/settings', data);
    return true;
  } catch (error) {
    console.error('Error updating settings:', error);
    return false;
  }
};

export const updateLocationPrinterSettings = async (locationId, data) => {
  try {
    await axiosInstance.post(`/settings/location-printer/${locationId}`, data);
    return true;
  } catch (error) {
    console.error('Error updating location printer settings:', error);
    return false;
  }
};

// Obtener URL presignada del logo
export const getLogoUrl = async () => {
  try {
    const response = await axiosInstance.get('/settings/logo');
    return response.data.data; // { url: "...", key: "..." } o { url: null, key: null }
  } catch (error) {
    console.error('Error getting logo URL:', error);
    return { url: null, key: null };
  }
};

// Obtener la imagen del logo directamente (para usar como src en img tag)
export const getLogoImageUrl = () => {
  // Retornar la URL directa que incluirá el token en el header automáticamente
  const baseURL = axiosInstance.defaults.baseURL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
  return `${baseURL}/logo/image`;
};

// Subir logo
export const uploadLogo = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axiosInstance.post('/settings/uploadLogo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error uploading logo:', error);
    throw error;
  }
};

// Biblioteca de logos alternativos (para facturas custom)
export const getCompanyLogos = async () => {
  try {
    const response = await axiosInstance.get('/settings/logos');
    return response.data.data || [];
  } catch (error) {
    console.error('Error getting company logos:', error);
    return [];
  }
};

// Devuelve una object URL (blob) con la imagen; id null = logo por defecto de la empresa.
export const fetchLogoPreviewUrl = async (id = null) => {
  try {
    const path = id ? `/settings/logos/${id}/image` : '/settings/logo/image';
    const response = await axiosInstance.get(path, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  } catch (error) {
    return null;
  }
};

export const uploadCompanyLogo = async (name, file) => {
  const formData = new FormData();
  formData.append('name', name);
  formData.append('file', file);
  const response = await axiosInstance.post('/settings/logos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data; // { id, name }
};

export const deleteCompanyLogo = async (id) => {
  await axiosInstance.delete(`/settings/logos/${id}`);
};
